var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.942,
    height: 46.5,
    viewBox: "0 0 28.942 46.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_85393",
    "data-name": "Path 85393",
    d: "M549.957,291.241a1.683,1.683,0,0,1-1.684-1.684,15.742,15.742,0,0,1,.934-5.706,12.989,12.989,0,0,1,2.216-3.65,41.871,41.871,0,0,1,4.037-3.912,19.164,19.164,0,0,0,3.791-4.1,6.586,6.586,0,0,0,.872-3.337,7.783,7.783,0,0,0-2.556-5.753,8.657,8.657,0,0,0-6.269-2.478,8.428,8.428,0,0,0-5.987,2.247,10.027,10.027,0,0,0-2.628,4.631,2.925,2.925,0,0,1-5.613-1.647,13.451,13.451,0,0,1,3.953-6.444Q544.871,256,551.2,256q6.7,0,10.7,3.65a11.525,11.525,0,0,1,3.991,8.825,11.176,11.176,0,0,1-1.4,5.519A26.174,26.174,0,0,1,559,280.137a28.049,28.049,0,0,0-3.588,3.587,7.944,7.944,0,0,0-1.247,2.65,16.732,16.732,0,0,0-.412,3.256,1.7,1.7,0,0,1-1.694,1.606h-2.1Zm-2,8.063a3.2,3.2,0,1,1,3.2,3.2A3.2,3.2,0,0,1,547.96,299.3Z",
    transform: "translate(-536.949 -256)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/q&a.922470a5c1ea6b9b9d7eaf24bf863955.svg";
export { ForwardRef as ReactComponent };